import { getQueryString } from "../modules/query-string";
import { saveLocationSelectionGlobal } from "../repos/locationSettings";
import {
  persistCustomerInfo,
  retrievePersistedCustomerInfo,
} from "../marketplace/marketplace-handler";
import { MarketplaceLocationInfo } from "./types";

export function isStandaloneApp() {
  return window.matchMedia("(display-mode: standalone)").matches;
}

const delayRedirect = (url: string) => {
  window.location.href = url;
};

export function allPropertiesExistAndAreNonEmptyStrings(obj: object, properties: Array<string>): boolean {
  // Loop through each property in the provided properties array
  for (let i = 0; i < properties.length; i++) {
    const propName = properties[i];
    
    // Check if the object doesn't have the property or it's not a non-empty string
    if (!Object.prototype.hasOwnProperty.call(obj, propName) || typeof obj[propName] !== 'string' || obj[propName].trim() === '') {
      return false;  // Return false if any property is missing or is not a non-empty string
    }
  }
  return true;  // If all specified properties exist and are non-empty strings, return true
}


/**
 * Sets the selected location and then redirects if necessary
 * @param clientLocation
 */
export async function handleLocationSettings(
  location: MarketplaceLocationInfo
) {
  if (location.locationId) {
    await saveLocationSelectionGlobal(location.locationId);
  }
  if (location.redirectUrl) {
    delayRedirect(location.redirectUrl);
  }
}

/**
 * Saves the customer info from the query string.  Currently only rewards number is saved.
 */
export function saveCustomerInfo() {
  const rewardsNum = getQueryString("rewardsnum");

  if (rewardsNum) {

    let customerInfo = retrievePersistedCustomerInfo();

    if (!customerInfo) {
      customerInfo = {
        FirstName: "",
        LastName: "",
        RewardsNumber: "",
        Email: "",
        Phone: "",
      };
    }

    customerInfo.RewardsNumber = rewardsNum;
    persistCustomerInfo(customerInfo);
  }
}
